import { render } from "./App.vue?vue&type=template&id=13ba7a5a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=13ba7a5a&lang=less"

import exportComponent from "/Users/wanglei/lnmp/www/study-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__